import { v4 as uuidv4 } from 'uuid';

const getDeviceId = () => {
  let deviceId = localStorage.getItem('DeviceID');
  if (!deviceId) {
    deviceId = uuidv4();
    localStorage.setItem('DeviceID', deviceId);
  }
  return deviceId;
};

export const initializeOneSignal = async (userId) => {
  try {


    await window.OneSignal.init({
      appId: process.env.REACT_APP_ONESIGNAL_APP_ID,
      notifyButton: {
        enable: true,
      },
      welcomeNotification: {
        title: "Hoş Geldiniz!",
        message: "Bildirimler başarıyla aktifleştirildi!",
      },
    });

    // Kullanıcı bilgilerini ilişkilendirin
    const deviceId = getDeviceId();
    window.OneSignal.setExternalUserId(userId);

    // Kullanıcıya özel bilgiler ekleyin
    window.OneSignal.sendTags({ userId, deviceId });

    // Bildirim izinlerini manuel olarak alın
    window.OneSignal.registerForPushNotifications();

    console.log("OneSignal başarıyla başlatıldı.");
  } catch (error) {
    console.error("OneSignal initialization error:", error);
  }
};
